if (!customElements.get("hero-slider")) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.initialize();
      window.addEventListener("shopify:block:select", (event) => {
        if (!event.target.closest("hero-slider") || !this.slider) {
          return;
        }
        const index = Number(event.target.dataset.index);
        this.slider.slideTo(index, 600);
      });
      this.addKeyboardNavigation();
    }

    initialize() {
      const mount = () => {
        this.mountSlider();
      };
      const loader = window.themeLibraryLoader;
      if (loader && typeof loader.whenSwiperReady === "function") {
        loader.whenSwiperReady(mount);
      } else if (window.Swiper) {
        mount();
      }
    }

    mountSlider() {
      const autoplayConfig = { delay: this.dataset.autoplayInterval };
      const prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const shouldAutoplay = this.dataset.autoplay === "true" && !prefersReducedMotion;
      this.slider = new Swiper(this, {
        effect: "fade",
        rewind: true,
        slidesPerView: 1,
        speed: 600,
        followFinger: false,
        navigation: {
          nextEl: ".swiper-button--next",
          prevEl: ".swiper-button--prev"
        },
        autoplay: shouldAutoplay ? autoplayConfig : false,
        on: {
          init: this.handleSlideChange.bind(this),
          slideChange: this.handleSlideChange.bind(this)
        }
      });
    }

    handleSlideChange(swiperInstance) {
      const header = document.querySelector(".header__inner");
      const heroSlides = document.querySelectorAll(".hero__inner");
      const buttons = this.querySelectorAll(".swiper-button");
      if (!header || !heroSlides.length || !buttons.length) {
        return;
      }
      document.documentElement.style.setProperty("--transparent-header-menu-text-color", heroSlides[swiperInstance.activeIndex].dataset.headerMenuTextColor);
      const content = this.querySelectorAll(".hero__content")[swiperInstance.activeIndex];
      const textClasses = Array.from(content.classList).filter((className) => className.startsWith("text-colors-"));
      buttons.forEach((button) => {
        Array.from(button.classList).forEach((className) => {
          if (className.startsWith("text-colors-")) {
            button.classList.remove(className);
          }
        });
        textClasses.forEach((className) => {
          button.classList.add(className);
        });
      });
    }

    addKeyboardNavigation() {
      document.addEventListener("keydown", (event) => {
        if (!this.isInViewport() || !this.slider) {
          return;
        }
        if (event.key === "ArrowRight") {
          const nextButton = this.querySelector(".swiper-button--next");
          nextButton?.click();
        }
        if (event.key === "ArrowLeft") {
          const prevButton = this.querySelector(".swiper-button--prev");
          prevButton?.click();
        }
      });
    }

    isInViewport() {
      const rect = this.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0;
    }
  }

  customElements.define("hero-slider", HeroSlider);
}
